import Layout from './app/layout'

const App = () => <Layout />

export default App
